import Box from "@mui/material/Box";
import grey from "@mui/material/colors/grey";
import { useMemo } from "react";
import Txt from "../typography/Txt";

const ChipItem = ({
  icon,
  value,
  sx,
  onClick,
  customContent,
  backgroundColor = grey[100],
  iconSize = 14,
  backgroundHoverColor,
  lineHeight = 1.2,
  color = "rgba(0, 0, 0, 0.6)",
}) => {
  const styles = useMemo(() => {
    return {
      "&.chip-item": {
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        px: 0.8,
        py: 0.4,
        // pr: 1.2,
        gap: 0.4,
        cursor: onClick ? "pointer" : "default",
        borderRadius: 1.5,
        minHeight: "26px",
        ".txt, .MuiSvgIcon-root": {
          color: color,
        },
        ".txt": {
          lineHeight,
          // lineHeight: 1.8,
          fontSize: "11px",
        },
        ".MuiSvgIcon-root": {
          fontSize: iconSize,
        },
        "&:hover": {
          backgroundColor: backgroundHoverColor,
        },
        ...sx,
      },
    };
  }, [
    backgroundColor,
    backgroundHoverColor,
    color,
    lineHeight,
    iconSize,
    onClick,
    sx,
  ]);
  return (
    <Box sx={styles} className="chip-item" onClick={onClick}>
      {icon}

      {customContent ? customContent : <Txt secondary>{value}</Txt>}
    </Box>
  );
};

export default ChipItem;
